import React, {useEffect, useState} from 'react';
import {TermsComponent} from '../../terms/components/TermsComponent';
import {definitions} from '../constants/definitions';

export function LicensePolicies() {
  const [licenseTerms, setLicenseTerms] = useState('');

  useEffect(() => {
    fetch('/third-party-licenses.txt')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.text();
      })
      .then((text) => {
        // Display all content without filtering to show complete license information
        setLicenseTerms(text);
      })
      .catch((error) => console.error('Error fetching license file:', error));
  }, []);
  return (
    <ol>
      <TermsComponent title="License Terms" terms={definitions} />
      <div className="terms-container">
        <pre>{licenseTerms}</pre>
      </div>
    </ol>
  );
}
